import React, { useState, useEffect } from 'react'
import { Link } from 'react-router-dom'
import { useAuth } from '../services/AuthContext'
import apiService from '../services/api'

const HomePage: React.FC = () => {
  const { user } = useAuth()
  const [downloadUrl, setDownloadUrl] = useState<string>('')
  const [os, setOs] = useState<string>('')

  useEffect(() => {
    // Detect OS
    const userAgent = navigator.userAgent.toLowerCase()
    let detectedOs = 'windows'
    
    if (userAgent.includes('mac')) {
      detectedOs = 'macos'
    } else if (userAgent.includes('linux')) {
      detectedOs = 'linux'
    }
    
    setOs(detectedOs)

    // Get download URL from server
    const getDownloadUrl = async () => {
      try {
        const url = await apiService.getWebappUrl()
        setDownloadUrl(url)
      } catch (error) {
        console.error('Failed to get download URL:', error)
      }
    }

    getDownloadUrl()
  }, [])

  const getDownloadButtonText = () => {
    if (!downloadUrl) return 'Download Emma Desktop'
    
    switch (os) {
      case 'macos':
        return 'Download for macOS'
      case 'linux':
        return 'Download for Linux'
      default:
        return 'Download for Windows'
    }
  }

  return (
    <div style={{ minHeight: '100vh', background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)' }}>
      {/* Header */}
      <header style={{ padding: '1rem 0', background: 'rgba(255, 255, 255, 0.1)', backdropFilter: 'blur(10px)' }}>
        <div className="container" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <Link to="/" style={{ display: 'flex', alignItems: 'center', lineHeight: 0 }}>
            <img src="/emma-logo.svg" alt="Emma" style={{ height: 64, width: 'auto', maxWidth: 'min(280px, 55vw)' }} />
          </Link>
          <nav style={{ display: 'flex', gap: '1rem' }}>
            {user ? (
              <>
                <Link to="/account" style={{ color: 'white', textDecoration: 'none' }}>Account</Link>
                <Link to="/subscribe" style={{ color: 'white', textDecoration: 'none' }}>Upgrade</Link>
                <button 
                  onClick={() => window.location.href = '/login'}
                  style={{ 
                    background: 'rgba(255, 255, 255, 0.2)', 
                    color: 'white', 
                    border: 'none', 
                    padding: '0.5rem 1rem', 
                    borderRadius: '0.5rem',
                    cursor: 'pointer'
                  }}
                >
                  Logout
                </button>
              </>
            ) : (
              <>
                <Link to="/login" style={{ color: 'white', textDecoration: 'none' }}>Login</Link>
                <Link to="/signup" style={{ color: 'white', textDecoration: 'none' }}>Sign Up</Link>
              </>
            )}
          </nav>
        </div>
      </header>

      {/* Hero Section */}
      <main style={{ padding: '4rem 0', textAlign: 'center' }}>
        <div className="container">
          <h1 style={{ 
            fontSize: '3rem', 
            fontWeight: 'bold', 
            color: 'white', 
            marginBottom: '1rem',
            textShadow: '0 2px 4px rgba(0,0,0,0.3)'
          }}>
            AI-Powered Video Editing
          </h1>
          <p style={{ 
            fontSize: '1.25rem', 
            color: 'rgba(255, 255, 255, 0.9)', 
            marginBottom: '2rem',
            maxWidth: '600px',
            margin: '0 auto 2rem'
          }}>
            Transform your videos with natural language commands. 
            Emma uses AI to understand your creative vision and generate the perfect video edits.
          </p>
          
          <div style={{ marginBottom: '3rem' }}>
            <a 
              href={downloadUrl || '#'}
              className="btn btn-primary"
              style={{ 
                fontSize: '1.25rem', 
                padding: '1rem 2rem',
                textDecoration: 'none',
                display: 'inline-block',
                background: '#3b82f6',
                color: 'white',
                borderRadius: '0.75rem',
                boxShadow: '0 4px 14px rgba(59, 130, 246, 0.4)',
                transition: 'all 0.2s'
              }}
            >
              {getDownloadButtonText()}
            </a>
          </div>

          {/* Features */}
          <div style={{ 
            display: 'grid', 
            gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))', 
            gap: '2rem', 
            marginTop: '4rem' 
          }}>
            <div style={{ 
              background: 'rgba(255, 255, 255, 0.1)', 
              padding: '2rem', 
              borderRadius: '1rem',
              backdropFilter: 'blur(10px)'
            }}>
              <h3 style={{ color: 'white', marginBottom: '1rem' }}>Natural Language</h3>
              <p style={{ color: 'rgba(255, 255, 255, 0.8)' }}>
                Just describe what you want: "make it darker", "add slow motion", "crop to 16:9"
              </p>
            </div>
            
            <div style={{ 
              background: 'rgba(255, 255, 255, 0.1)', 
              padding: '2rem', 
              borderRadius: '1rem',
              backdropFilter: 'blur(10px)'
            }}>
              <h3 style={{ color: 'white', marginBottom: '1rem' }}>AI-Powered</h3>
              <p style={{ color: 'rgba(255, 255, 255, 0.8)' }}>
                Advanced AI understands your creative intent and generates perfect code
              </p>
            </div>
            
            <div style={{ 
              background: 'rgba(255, 255, 255, 0.1)', 
              padding: '2rem', 
              borderRadius: '1rem',
              backdropFilter: 'blur(10px)'
            }}>
              <h3 style={{ color: 'white', marginBottom: '1rem' }}>Professional Results</h3>
              <p style={{ color: 'rgba(255, 255, 255, 0.8)' }}>
                Generate high-quality video edits with industry-standard tools
              </p>
            </div>
          </div>
        </div>
      </main>

      {/* Footer */}
      <footer style={{ 
        padding: '2rem 0', 
        background: 'rgba(0, 0, 0, 0.2)', 
        textAlign: 'center',
        color: 'rgba(255, 255, 255, 0.7)'
      }}>
        <div className="container">
          <p>&copy; 2024 Emma. All rights reserved.</p>
        </div>
      </footer>
    </div>
  )
}

export default HomePage
